import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useTrpImplementation } from "../../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";

const SubProject = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 12, xs: 12 };
const SubProjectType = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 12, xs: 12 };
const VendorsByGender = { xxl: 5, xl: 5, lg: 5, md: 5, sm: 12, xs: 12 };
const Vulnerability = { xxl: 5, xl: 5, lg: 5, md: 5, sm: 0, xs: 0 };
const CategoryOfVendors = {
  xxl: 5,
  xl: 4,
  lg: 4,
  md: 4,
  sm: 0,
  xs: 0,
  style: { whiteSpace: "normal", wordBreak: "break-word", maxWidth: 400 },
};

const headerLayout = [
  { ...SubProject, header: "Sub-project" },
  { ...SubProjectType, header: "Sub-project Type" },
  { ...VendorsByGender, header: "Vendors by gender" },
  { ...Vulnerability, header: "Vulnerability" },
  { ...CategoryOfVendors, header: "Category of Vendors" },
];


const TrpImplementation = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { trpImplementations = [], pagination, loading } = useTrpImplementation(
    packageId,
    startDate,
    endDate,
    currentPage,
    pageSize
  );
  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name;
  
  const items = trpImplementations;

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    if (size !== pageSize) {
      setPageSize(size);
    }
  };

  const openDrawer = (item) => {
    setActiveItem(item);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
    setActiveItem(null);
  };

  return (
    <>
      <div style={{ width: "100%", padding: "24px" }}>
        <ActionBar
          actionButtonProp={{
            title: `${packageName}: TRP Implementation`,
          }}
        />

        <div className="prst-table">
          <CustomList
            itemName="TRP Implementation"
            items={items}
            page={currentPage}
            itemCount={pagination?.total || (items?.length ?? 0)}
            loading={loading}
            headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id}
              name={item?.sub_project || "-"}
              item={item}
              isPackage={false}
              renderActions={() => false}
              onClick={() => openDrawer(item)}
              style={{
                backgroundColor:
                  activeItem?.id === item.id ? "#f0f0f0" : "transparent",
              }}
            >
              <Col {...SubProject} className="contentEllipse" data-label="Sub-project">
                {item.sub_project || "--//--"}
              </Col>
              <Col {...SubProjectType} className="contentEllipse" data-label="Sub-project Type">
                {item.sub_project_type?.length > 15 ? item.sub_project_type?.slice(0, 15) + "..." : item.sub_project_type || "--//--"}
              </Col>
              <Col {...VendorsByGender} className="contentEllipse" data-label="Vendors by gender">
                {item.vendors_by_gender?.length > 30 ? item.vendors_by_gender?.slice(0, 30) + "..." : item.vendors_by_gender || "--//--"}
              </Col>
              <Col {...Vulnerability} className="contentEllipse" data-label="Vulnerability">
                {Array.isArray(item.vulnerabilities) &&
                item.vulnerabilities.length > 0
                  ? item.vulnerabilities.slice(0, 4).map((v, idx) => (
                      <span
                        key={v.id}
                        // style={{
                        //   marginRight: 4,
                        //   borderRadius: 4,
                        //   padding: "2px 8px",
                        //   fontSize: 12,
                        //   display: "inline-block",
                        // }}
                      >
                        {v.vulnerability}
                        {v.count !== null ? `(${v.count})` : ""}
                      </span>
                    ))
                  : "--//--"}
                {item.vulnerabilities && item.vulnerabilities.length > 4 ? (
                  <span style={{ marginLeft: 4 }}>...</span>
                ) : null}
              </Col>
              <Col {...CategoryOfVendors} className="contentEllipse" data-label="Category of Vendors">
                {Array.isArray(item.vendor_categories) &&
                item.vendor_categories.length > 0
                  ? item.vendor_categories.slice(0, 1).map((cat, idx) => (
                      <span
                        key={cat.id}
                        // style={{
                        //   marginRight: 4,
                        //   borderRadius: 4,
                        //   padding: "2px 8px",
                        //   fontSize: 12,
                        //   display: "inline-block",
                        // }}
                      >
                        {`${cat.category} (${cat.count})`.length > 25 ? `${cat.category} (${cat.count})`.slice(0, 25) + "..." : `${cat.category} (${cat.count})`}
                      </span>
                    ))
                  : "--//--"}
              </Col>
              
              {/* View Details Button for Mobile */}
              <div className="view-card-details" onClick={() => openDrawer(item)}>
                View Details
              </div>
            </ListItem>
          )}
          />
        </div>

        {/* Pagination */}
        {pagination && (
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            loading={loading}
          />
        )}
      </div>

      <Drawer
          title="TRP Implementation Details"
          placement="right"
          closable={true}
          onClose={closeDrawer}
          visible={drawerVisible}
          width={720}
        >
          {activeItem && (
            <div>
              <p>
                <strong>Sub-project:</strong> {activeItem?.sub_project || "-"}
              </p>
              <p>
                <strong>Sub-project Type:</strong>{" "}
                {activeItem?.sub_project_type || "-"}
              </p>
              <p>
                <strong>Vendors by gender:</strong>{" "}
                {activeItem?.vendors_by_gender || "-"}
              </p>
              <p>
                <strong>Vulnerability:</strong>
                {Array.isArray(activeItem?.vulnerabilities) &&
                activeItem.vulnerabilities.length > 0
                  ? activeItem.vulnerabilities.map((v) => (
                      <span
                        key={v.id}
                        style={{
                          marginRight: 4,

                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: 12,
                          display: "inline-block",
                        }}
                      >
                        {v.vulnerability}
                        {v.count !== null ? `(${v.count})` : ""}
                      </span>
                    ))
                  : "-"}
              </p>
              <p>
                <strong>Category of Vendors:</strong>
                {Array.isArray(activeItem?.vendor_categories) &&
                activeItem.vendor_categories.length > 0
                  ? activeItem.vendor_categories.map((cat) => (
                      <span
                        key={cat.id}
                        style={{
                          marginRight: 4,

                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: 12,
                          display: "inline-block",
                        }}
                      >
                        {cat.category}
                        {cat.count !== null ? `(${cat.count})` : ""}
                      </span>
                    ))
                  : "-"}
              </p>
            </div>
          )}
        </Drawer>
    </>
  );
};

export default TrpImplementation;
